/**
 * Generates a function that passes an initial value and chain the result of each to the next
 * function in the array of fns
 * @param fns
 */
export const compose =
  <T1 = any, T2 = any>(...fns: Function[]) =>
  (collection: T1): T2 =>
    fns.reduce((next, fn) => fn(next), collection);
